import { render, staticRenderFns } from "./relationPresTransferSport.vue?vue&type=template&id=0e0132ab&scoped=true&"
import script from "./relationPresTransferSport.vue?vue&type=script&lang=ts&"
export * from "./relationPresTransferSport.vue?vue&type=script&lang=ts&"
import style0 from "./relationPresTransferSport.vue?vue&type=style&index=0&id=0e0132ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0132ab",
  null
  
)

export default component.exports